<template>
<div id="findpasswordpage" class="loginregist" v-title data-title="找回密码">
	<img src="../../assets/loginlogo.png" alt=""  class="loginlogo">
	<div class="loginblock"> 
		<div class="register-title oh"><span class="current">找回密码</span></div>
		<div class="current login-sms login-form">
			<div class="login-line">
				<input type="text" class="underlinput underlinput1" maxlength="11" placeholder="手机号" name="mobilephone" v-model="mobilephone" @keyup="errortext='';verifyphone($event)">
			</div>
				<div class="login-line getverifyline">
					<input type="text" class="underlinput underlinput2" placeholder="短信验证码" name="smsverify" v-model="smsverify" @keydown="errortext='';">
					<span :class="isphonenum&&unclicked ?'current smsverifybtn':'smsverifybtn'" @click="getsmsverifycode($event)">获取短信验证码</span>
				</div>
				<div class="login-line">
					<input type="password" class="underlinput underlinput1" placeholder="请设置新密码" name="password" v-model="password" @keydown="errortext=''; ">
				</div>
				<div class="login-line">
					<input type="password" class="underlinput underlinput1" placeholder="再次确认密码" name="password1" v-model="password1" @keydown="errortext=''; " >
				</div>
				<div class="login-link oh">
					<router-link class="a-router fl" to="/register">记得密码？去登录</router-link>
					<router-link class="a-router fr" to="/register">新用户注册</router-link> 
				</div>
				<div class="loginsubmit submitbtn" @click="registerfun()">确认</div>  
		</div>
		<p class="errortext" v-show="errortext!=''">{{errortext}}</p>
	</div>  
</div>
</template>

<script>
	export default {
	  name: 'findPassword',
			data(){
				return{
				mobilephone:"",password:"",password1:"",smsverify:"", errortext:"",count:60,isphonenum:false,unclicked:true,
			}}, 
		 methods:{
				setlocaldata:function(){
					let newUserDate;
					if(typeof(this.$store.state.userData) == 'string'){
					 　　newUserDate = JSON.parse(this.$store.state.userData);
					}else{
					　　 newUserDate = this.$store.state.userData;
					}
					newUserDate.mobileNo = this.ruleForm.phoneNumber;　　//修改其中参数的值
					this.$store.commit('setUserData',newUserDate);　　　　//使用该方法调用setUserData更新userData的值
					this.$refs.head_child.getPersonalInfo();　　　　　　　 //刷新个人信息
				},
				registerfun:function(){
					const _this=this;
					if(this.mobilephone =="" || this.password1 =="" || this.smsverify ==""){
						this.errortext="内容未填写完整";
					}else if(this.password != this.password1){
						this.errortext="两次密码不一致"; 
					}else{
						this.$axios.post('http://192.168.1.86:8100/cmsapi/v1/admin/login?username='+_this.mobilephone+'&password='+_this.password1).then(function(res){
							var resdata=res.data; 
							if(resdata.success){ 
								console.log(resdata.data);
								var datasm=resdata.data;
								if (typeof datasm === 'object') {
										datasm = JSON.stringify(datasm)
								}
							localStorage.setItem('userData', datasm);
							_this.common.userdata=datasm;
							_this.common.islogin=true; 
								_this.$router.push({path: "/"});
							}else{
								_this.errortext=resdata.msg;
							} 
						}).catch(function (error) { 
							// 请求失败处理 console.log(error);
						}); 
					} 
				},
				//获取验证码
				getsmsverifycode:function($el){
					var _this=this;
					if(_this.isphonenum && _this.unclicked){
						 var codetext=$el.target.textContent; 
							// this.$axios.post('http://192.168.1.86:8100/cmsapi/v1/admin/login?username='+_this.username+'&password='+_this.password).then(function(res){
							// 	var resdata=res.data; 
							// 	if(resdata.success){
							_this.unclicked=false;var coutnum=_this.count,timer;
							timer=setInterval(function(){ 
							if(coutnum == 0){
								clearInterval(timer);
								_this.unclicked=true;
								$el.target.textContent="重新发送验证码"
							}else{
								coutnum--;
								$el.target.textContent="已发送 "+coutnum+"S后重试";
							} 
							},1000) 
							// 	}else{
							// 		_this.errortext=resdata.msg;
							// 	} 
							// }).catch(function (error) { 
							// 	// 请求失败处理 console.log(error);
							// });  
						}; 
				},
				//验证手机号
				verifyphone:function($el){
					var values=$el.target.value; 
					var myStr = /^[1][3,4,5,8,7,9,6][0-9]{9}$/;
					this.isphonenum=myStr.test(values); 
				},  	
					
					
					
					
		},
	} 
</script>

<style> 
	
	
</style>
